import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Select, { ISelectValue } from '@/components/basicComponents/select';
import { ITenant } from '@/components/investors-page/types';
import { themeVar } from '@/styles/theme';
import { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import styled from 'styled-components';

interface AddNewUserProps {
  isOpen: boolean;
  advisoryFirmList: ITenant[];
  handleOpenModifyUserModalPage: ({ open }: { open: boolean; tenantId?: string }) => void;
  onClose: () => void;
}

const AddNewUser = ({ isOpen, advisoryFirmList, handleOpenModifyUserModalPage, onClose }: AddNewUserProps) => {
  const { handleSubmit, control } = useForm<{ advisoryFirmId: string }>({ defaultValues: { advisoryFirmId: '' } });

  const [selectListData, setSelectListData] = useState<ISelectValue[]>([]);

  useEffect(() => {
    setSelectListData([...new Set(advisoryFirmList.map((el) => ({ label: el.name, value: el.id })))].sort((a, b) => a.label.localeCompare(b.label)));
  }, [advisoryFirmList]);

  const onSave = ({ advisoryFirmId }: { advisoryFirmId: string }) => {
    handleOpenModifyUserModalPage({ open: true, tenantId: advisoryFirmId });
    onClose();
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title="Add New User"
      confirmButton={{
        name: 'Confirm',
        onClick: handleSubmit(onSave)
      }}
    >
      <ModalBody>
        <ModalDescription>Select an Advisory Firm</ModalDescription>
        <Controller
          name="advisoryFirmId"
          control={control}
          rules={{
            required: {
              value: true,
              message: 'Advisory Firm is required'
            }
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Select
              label="Advisory Firm"
              value={value || ''}
              options={selectListData}
              setValue={onChange}
              errorText={error?.message}
              isRequiredField
              size="lg"
            />
          )}
        />
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default AddNewUser;

const ModalBody = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  gap: 25px;
`;

const ModalDescription = styled.div`
  font-size: 16px;
  text-align: center;
  color: ${themeVar('font.base')};
`;
